import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

export interface UrlPreviewData {
  url: string;
  title?: string;
  description?: string;
  image?: string;
}

@Injectable({
  providedIn: 'root',
})
export class UrlPreviewService {
  private urlRegex = /(https?:\/\/[^\s]+)/g;

  constructor(private http: HttpClient) {}

  extractUrls(text: string): string[] {
    return text.match(this.urlRegex) || [];
  }

  hasUrl(text: string): boolean {
    return this.urlRegex.test(text);
  }

  // This uses a CORS proxy to fetch metadata from URLs
  // You might want to implement your own proxy or use a service like https://cors-anywhere.herokuapp.com/
  getUrlPreview(url: string): Observable<UrlPreviewData> {
    // For security, we'll only preview http/https URLs
    if (!url.match(/^https?:\/\//)) {
      return of({ url });
    }

    // Use a meta scraper service or implement your own proxy
    const proxyUrl = `https://api.microlink.io?url=${encodeURIComponent(url)}`;

    return this.http.get(proxyUrl).pipe(
      map((response: any) => ({
        url: url,
        title: response.data?.title || '',
        description: response.data?.description || '',
        image: response.data?.image?.url || '',
      })),
      catchError(() => of({ url }))
    );
  }
}

